// @flow strict

import {combineReducers} from 'redux';

import type {Events as SchedulerEventsState} from 'src/types/scheduler/events.js';
import type {SchedulerEventActions} from 'src/action-creators/scheduler/events';
import type {SchedulerDashboardState} from './dashboard';
import type {SchedulerDashboardActions} from 'src/action-creators/scheduler/dashboard';
import type {SchedulerSettingsState} from './settings';
import type {SchedulerSettingsActions} from 'src/action-creators/scheduler/settings';
import type {Holidays} from 'src/types/scheduler/holidays.js';
import type {SchedulerHolidayActions} from 'src/action-creators/scheduler/holidays';

import type {SchedulerTemplatesState} from 'src/types/scheduler/templates';
import type {SchedulerTemplatesActions} from 'src/action-creators/scheduler/templates';

import type {SchedulerGlobalState} from './global.js';
import type {SchedulerGlobalActions} from 'src/action-creators/scheduler/global';

import type {SchedulerTemplateForm} from 'src/types/scheduler/template-form';
import type {SchedulerTemplateFormActions} from 'src/action-creators/scheduler/template-form';

import {default as events} from './events.js';
import {default as dashboard} from './dashboard.js';
import {default as settings} from './settings.js';
import {default as templates} from './templates.js';
import {default as holidays} from './holidays.js';
import {default as global} from './global.js';
import {default as templateForm} from './template-form.js';


export type State = {|
  events: SchedulerEventsState,
  dashboard: SchedulerDashboardState,
  settings: SchedulerSettingsState,
  templates: SchedulerTemplatesState,
  holidays: Holidays,
  global: SchedulerGlobalState,
  templateForm: SchedulerTemplateForm,
|};

type Action =
  | SchedulerEventActions
  | SchedulerDashboardActions
  | SchedulerSettingsActions
  | SchedulerTemplatesActions
  | SchedulerHolidayActions
  | SchedulerGlobalActions
  | SchedulerTemplateFormActions;

const reduce: (state: State, action: Action) => State = combineReducers({
  events,
  dashboard,
  settings,
  templates,
  holidays,
  global,
  templateForm,
});

export default reduce;
